import React, { useState, useEffect } from "react";
import { ControlsSwitch } from "./../ControlsSwitch";
import { ControlsRow } from "./../ControlsRow";
import { ImportantButton } from "./../ImportantButton";
import { BooksSettingsControls } from "./../BooksSettingsControls";
import { PrivateCategoriesSettingsControls } from "./../PrivateCategoriesSettingsControls";

import {getBooks, getPrivateCategories, getSettings} from "api";
import {useExtendedMutation, runAllMutationsWithArgs} from "mutations";

const SettingsControls = ({token}) => {
  const [privateCardsEnabled, setPrivateCardsEnabled] = useState(false);
  const [currentSettings, setCurrentSettings] = useState({});
  const [books, setBooks] = useState([]);
  const [privateCategories, setPrivateCategories] = useState([]);
  
  const onChangeSwitch = () => {
    setPrivateCardsEnabled(!privateCardsEnabled)
  }

  const onBookSuccess = (data) => {
    setBooks(data);
  }

  const onPrivateCategoriesSuccess = (data) => {
    setPrivateCategories(data);
  }

  const onCurrentSettingsSuccess = (data) => {
    setCurrentSettings(data);
  }

  const onError = (error) => {
    console.log(error);
  }

  const currentSettingsMutation = useExtendedMutation(getSettings, onCurrentSettingsSuccess, onError);
  const bookMutation = useExtendedMutation(getBooks, onBookSuccess, onError);
  const privateCategoriesMutation = useExtendedMutation(getPrivateCategories, onPrivateCategoriesSuccess, onError);

  useEffect(() => {
    runAllMutationsWithArgs([
        {mutation: currentSettingsMutation, input: {token: token}},
        {mutation: bookMutation, input: {token: token}},
        {mutation: privateCategoriesMutation, input: {token: token}}
      ])
  }, []); //TODO rewrite this so that you first fetch the current settings, probably somewhere else and then here it will depend on it.

  return (
    <>
      <ControlsRow>
        {privateCardsEnabled 
          ? (<PrivateCategoriesSettingsControls token={token}/>)
          : (<BooksSettingsControls token={token}/>)}
        <ControlsSwitch
          labelOn={"Book Mode Disabled"}
          labelOff={"Book Mode Enabled"}
          onChange={onChangeSwitch}
          toggle = {privateCardsEnabled}
        />
      </ControlsRow>
      <ControlsRow horizontalOnMobile = {true} >
        <ImportantButton 
          buttonText={"Cancel"}
          onClick={() => {}}
        />
        <ImportantButton
          buttonText={"Apply"}
          onClick={() => {}}
        />
      </ControlsRow>
    </>
  );
}

export { SettingsControls }
